import authHeader from "./auth.header"
import constants from './constants.js'

const HOST_URL = constants.API_URL

export async function fetchIgo(firstElement, lastElement, query) {
    let response
    if (query === '') {
        response = await fetch(HOST_URL + `/igo/${firstElement}/${lastElement}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    } else {
        response = await fetch(HOST_URL + `/igo/${firstElement}/${lastElement}/${query}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                ...authHeader()
            },
        })
    }
    const data = await response.json()
    return data
}

export async function fetchIgoById(igoId) {
    const response = await fetch(HOST_URL + '/igo/' + igoId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function updateIgo(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/edit', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(request)
    })
    const data = await response.json()
    return data
}

export async function deleteIgo(igoId) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/delete/' + igoId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function addIgo(request) {
    const userAdmin = JSON.parse(localStorage.getItem('user'))
    if (!userAdmin.admin && userAdmin.admin_access !== 5) return
    const response = await fetch(HOST_URL + '/igo/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(request)
    })
    const data = await response.json()
    return data
}

export async function getIgoLogo(igoId) {
    const response = await fetch(HOST_URL + '/igo/logo/' + igoId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}

export async function setIgoLogo(igoId, file) {
    const formData = new FormData()
    formData.append('file', file)
    const response = await fetch(HOST_URL + '/igo/logo/' + igoId, {
        method: 'POST',
        headers: {
            ...authHeader()
        },
        body: formData
    })
    if (!response.ok) {
        console.error('Error uploading file:', response.statusText)
        return false
    }
    return true
}


export async function getUserCountry(userId) {
    const response = await fetch(HOST_URL + '/country/user/' + userId, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            ...authHeader()
        }
    })
    const data = await response.json()
    return data
}